import { CanvasRactive } from './CanvasRactive';
import { HeatMapDrawer } from './HeatmapDrawer';

export class HeatmapRactive extends CanvasRactive {
    oninit (): void {
        super.oninit();
        super.setDrawer(new HeatMapDrawer());
    }
}
